import {Model} from 'MWC';

export default class extends Model {
    static fields;

    isValid = false;

    constructor(data) {
        super();
        this.initData(data);
    }

    initData(data) {
        this.fields = {
            documentCode: {
                value: '',
                errors: ''
            }
        };
    }

    run(data) {
        const name = data.name;
        const value = data.value.replace(/[^\w]/g, '').toUpperCase();
        this.formatCode(value, name);
    }

    formatCode(value, name) {
        this.fields[name].value = value ? value.match(/.{1,4}/g).join('-') : '';
        this.isNotEmpty(value, name);
    }

    isNotEmpty(value, name) {
        this.fields[name].errors = value ? '' : 'SERVICE_CHECK_DOCUMENT_ERROR_EMPTY';
        this.isValid = !!value;
    }

    clearValue() {
        this.fields.documentCode.value = '';
        this.isValid = false;
    }
}
